/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import './TherapyCapSummary.scss'
import { Collapse, CardBody, Card, CardHeader, Container } from 'reactstrap'
import { DescriptionsComponent } from '../../Medicare/Descriptions/Descriptions'
import { LimitationsComponent } from '../../Medicare/Limitations/Limitations'
import { ExclusionsComponent } from '../../Medicare/Exclusions/Exclusions'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IBaseSection, ICoverageDiscoveryResponseStateManager } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { AcupunctureLimitations } from '../../Medicare/AcupunctureLimitations/AcupunctureLimitations'

export interface ITherapyCapSummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}
interface ITherapyCapSummaryState {
	collapse: number
}
export class TherapyCapSummary extends React.Component<ITherapyCapSummaryProps, ITherapyCapSummaryState> {
	constructor(props: Readonly<ITherapyCapSummaryProps>) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = { collapse: 0 }
	}
	toggle(e): void {
		const event = e.target.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}

	renderTherapyCapSummary2 = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('2') !== -1 ? true : false
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={4}>
						<h4>OT/PT/ST Caps</h4>
					</td>
				</tr>
			</tbody>
		)
	}

	renderPhysicalTypedataSummary = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('2') !== -1 ? true : false
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={2}>
						<h4>Physical / Speech Therapy</h4>
					</td>
					<td className="summaryHide" colSpan={2}></td>
				</tr>
			</tbody>
		)
	}

	renderOccupationalTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('2') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.occupationalType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="sub-header">
						<td colSpan={4}>{val.summary.occupationalType && val.summary.occupationalType.definition}</td>
					</tr>
					{val.summary.occupationalType &&
						val.summary.occupationalType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Occupational Therapy information available</td>
					</tr>
				</tbody>
			)
		}
	}
	renderPhysicalTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('2') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.physicalType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="sub-header">
						<td colSpan={4}>Physical / Speech Therapy</td>
					</tr>
					{val.summary.physicalType &&
						val.summary.physicalType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Physical / Speech Therapy information available</td>
					</tr>
				</tbody>
			)
		}
	}
	renderTherapyCapSummary3 = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('3') !== -1
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={2}>
						<h4>Pulmonary Rehab Service Limits</h4>
					</td>
					<td className="summaryHide" colSpan={2}></td>
				</tr>
			</tbody>
		)
	}
	renderPulmonaryTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('3') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.pulmonaryType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					{val.summary.pulmonaryType &&
						val.summary.pulmonaryType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Pulmonary Rehab Service Limits available</td>
					</tr>
				</tbody>
			)
		}
	}
	renderTherapyCapSummary4 = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('4') !== -1
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={2}>
						<h4>Cardiac Rehab</h4>
					</td>
					<td className="summaryHide" colSpan={2}></td>
				</tr>
			</tbody>
		)
	}
	renderCardiacTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('4') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.cardiacType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					{val.summary.cardiacType &&
						val.summary.cardiacType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Cardiac Rehab information available</td>
					</tr>
				</tbody>
			)
		}
	}
	renderTherapyCapSummary5 = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('5') !== -1
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={2}>
						<h4>Blood Deductible</h4>
					</td>
					<td className="summaryHide" colSpan={2}></td>
				</tr>
			</tbody>
		)
	}
	renderBloodTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('5') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.bloodType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					{val.summary.bloodType &&
						val.summary.bloodType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
					{val.summary.bloodType && <ExclusionsComponent data={val.summary.bloodType} />}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Blood Deductible information available</td>
					</tr>
				</tbody>
			)
		}
	}
	renderTherapyCapSummary6 = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('6') !== -1
		return (
			<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
				<tr className="summarySection">
					<td colSpan={2}>
						<h4>Smoking Cessation</h4>
					</td>
					<td className="summaryHide" colSpan={2}>
						<input type="hidden" value="6" />
					</td>
				</tr>
			</tbody>
		)
	}
	renderSmokingTypedata = (val: IBaseSection) => {
		const SelectedSections = val.summary.selectedSections.indexOf('6') !== -1
		if (!CommonUtils.isUndefinedOrNull(val.summary.smokingType)) {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					{val.summary.smokingType &&
						val.summary.smokingType.insurances.map((x, index) => {
							return (
								<Fragment key={index}>
									<DescriptionsComponent data={x} />
									<LimitationsComponent data={x} />
								</Fragment>
							)
						})}
				</tbody>
			)
		} else {
			return (
				<tbody className="summaryBody" style={{ display: SelectedSections ? '' : 'none' }}>
					<tr className="no-info">
						<td colSpan={4}>No Smoking Cessation information available</td>
					</tr>
				</tbody>
			)
		}
	}

	renderAcupunctureBenefitLimits = (val: IBaseSection) => {
		const selectedSections = val.summary.selectedSections.indexOf('7') !== -1
		return (
			<>
				<tbody className="summaryBody" style={{ display: selectedSections ? '' : 'none' }}>
					<tr className="summarySection">
						<td colSpan={2}>
							<h4>Acupuncture Benefit Limits</h4>
						</td>
						<td className="summaryHide" colSpan={2}>
							<input type="hidden" value="7" />
						</td>
					</tr>
				</tbody>
				<tbody className="summaryBody" style={{ display: selectedSections ? '' : 'none' }}>
					{val.summary.acupuncture && val.summary.acupuncture.insurances && val.summary.acupuncture.insurances.length > 0 ? (
						val.summary.acupuncture.insurances.map((x, index) => <AcupunctureLimitations data={x} key={index} />)
					) : (
						<tr className="no-info">
							<td colSpan={4}>No Acupuncture Benefit Limits information available</td>
						</tr>
					)}
				</tbody>
			</>
		)
	}

	render(): React.ReactNode {
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedMedicareTherapyCapSection
		if (!this.props.CoverageDiscoveryResponseStateManager.selectedMedicareTherapyCapSection) return <></>
		else {
			const { collapse } = this.state
			return (
				<div>
					<div className="accordion-group service-coverage">
						<div id={section.id} className="section" data-loadorder={section.loadOrder} data-index={section.summary.index}>
							<Card style={{ marginBottom: '1rem' }} className="card" key={section.displayOrder}>
								<CardHeader onClick={this.toggle} data-event={section.displayOrder} className="service-coverage accordion-heading whiteText">
									{section.summary && section.summary.title}
								</CardHeader>
								<Collapse isOpen={collapse === section.displayOrder}>
									<CardBody className="card-body">
										<Container style={{ margin: 0, padding: 0, width: '100%' }}>
											<div className="cdResponsePage">
												<table className="service-types-table">
													<tbody>
														<tr className="summaryDisplaying">
															<td colSpan={4}>
																Displaying {section.summary.selectedSections.length} of {section.summary.sections.length} sections
															</td>
														</tr>
													</tbody>
													{this.renderTherapyCapSummary2(section)}
													{this.renderOccupationalTypedata(section)}
													{this.renderPhysicalTypedataSummary(section)}
													{this.renderPhysicalTypedata(section)}
													{this.renderTherapyCapSummary3(section)}
													{this.renderPulmonaryTypedata(section)}
													{this.renderTherapyCapSummary4(section)}
													{this.renderCardiacTypedata(section)}
													{this.renderTherapyCapSummary5(section)}
													{this.renderBloodTypedata(section)}
													{this.renderTherapyCapSummary6(section)}
													{this.renderSmokingTypedata(section)}
													{this.renderAcupunctureBenefitLimits(section)}
												</table>
											</div>
										</Container>
									</CardBody>
								</Collapse>
							</Card>
						</div>
					</div>
				</div>
			)
		}
	}
}
